import React from 'react';
import { Palette } from 'lucide-react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const StylesSection = ({
  borderColor,
  borderWidth,
  borderStyle,
  borderRadius,
  opacity,
  onBorderColorChange,
  onBorderWidthChange,
  onBorderStyleChange,
  onBorderRadiusChange,
  onOpacityChange,
}) => (
  <div className="space-y-3">
    <h3 className="font-semibold text-sm flex items-center gap-2">
      <Palette className="w-4 h-4" />
      Estilos
    </h3>

    <div className="space-y-3">
      <div className="space-y-2">
        <Label className="text-xs">Borde</Label>
        <div className="flex gap-2">
          <div className="relative w-9 h-9 flex-shrink-0">
            <Input
              type="color"
              value={borderColor}
              onChange={onBorderColorChange}
              className="w-full h-full p-0 border-0 rounded-md overflow-hidden cursor-pointer"
            />
          </div>
          <Input
            type="number"
            min="0"
            max="20"
            value={borderWidth}
            onChange={onBorderWidthChange}
            placeholder="px"
            className="w-20"
          />
          <Select value={borderStyle} onValueChange={onBorderStyleChange}>
            <SelectTrigger className="flex-1">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="solid">Sólido</SelectItem>
              <SelectItem value="dashed">Guiones</SelectItem>
              <SelectItem value="dotted">Punteado</SelectItem>
              <SelectItem value="double">Doble</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="space-y-2">
        <Label className="text-xs">Radio de Esquina (px)</Label>
        <Input type="number" min="0" max="100" value={borderRadius} onChange={onBorderRadiusChange} />
      </div>

      <div className="space-y-2">
        <Label className="text-xs">Opacidad: {opacity}%</Label>
        <Input
          type="range"
          min="0"
          max="100"
          value={opacity}
          onChange={onOpacityChange}
          className="w-full"
        />
      </div>
    </div>
  </div>
);

export default StylesSection;
